import { i18n } from '@/local/index';
const { t } = i18n.global;

export const getCouponRightText = function (status) {
  switch (status) {
    case 'EXHAUSTED':
      return t('modules.couponsList.ALREADY_SOLD_OUT');
    case 'EXPIRED':
      return t('modules.couponsList.EXPIRED');
    case 'ACTIVE':
      return t('modules.couponsList.TAKE_IT_NOW');
    case 'USED':
      return t('modules.couponsList.USED');
    case 'UNAVAILABLE':
      return t('modules.couponsList.UNAVAILABLE');
    case 'REDEEMED':
      return t('modules.couponsList.TO_USE');
    default:
      return t('modules.couponsList.AVAILABLE_GOODS');
  }
};

export const getKeywordHighlightPart = function (promotion) {
  if (!promotion || !promotion.promotionCategory) return '';

  if (
    !promotion.benefits ||
    !promotion.benefits.length ||
    promotion.benefits.length < 1
  ) {
    return '';
  }
  const benefits = promotion.benefits;

  switch (promotion.promotionCategory) {
    case 'buyAmountXGetPercentOffX':
    case 'buyQuantityXGetPercentOffX':
    case 'forEachQuantityXGetPercentOffQuantityX':
      return (
        (100 -
          benefits[0].percentage.value -
          ((100 - benefits[0].percentage.value) % 10)) /
        10
      );
    case 'buyAmountXGetAmountOffX':
    case 'buyAmountXGetAmountOffY':
    case 'buyQuantityXGetAmountOffX':
    case 'forEachQuantityXGetAmountOffX':
      return benefits[0].fixedAmount.amount;
    case 'buyQuantityXGetQuantityFreeX':
    case 'forEachQuantityXGetQuantityFreeX':
    case 'buyAmountXGetQuantityFreeY':
    case 'buyAmountXGetQuantityFreeMultipleY':
    case 'buyQuantityXGetQuantityFreeY':
    case 'buyQuantityXGetQuantityFreeMultipleY':
    case 'buyQuantityXQuantityYGetQuantityFreeZ':
    case 'buyAmountXAmountYGetQuantityFreeZ':
    case 'forEachQuantityXGetQuantityFreeY':
    case 'forEachQuantityXGetQuantityFreeMultipleY':
    case 'buyAmountXGetQuantityFreeGiftCard':
    case 'buyQuantityXGetQuantityFreeGiftCard':
    case 'forEachQuantityXGetQuantityFreeGiftCard':
      return t('common.buyGift');
    case 'buyAmountXGetShippingFreeX':
    case 'buyQuantityXGetShippingFreeX':
    case 'buyAmountXGetSimpleShippingFreeX':
    case 'buyQuantityXGetSimpleShippingFreeX':
      return t('common.freeDelivery');
    case 'buyAmountXGetAmountOffMultipleY':
    case 'buyAmountXGetPercentOffY':
    case 'buyAmountXGetPercentOffMultipleY':
    case 'buyQuantityXGetAmountOffY':
    case 'buyQuantityXGetAmountOffMultipleY':
    case 'buyQuantityXGetPercentOffY':
    case 'buyQuantityXGetPercentOffMultipleY':
    case 'forEachQuantityXGetAmountOffY':
    case 'forEachQuantityXGetAmountOffMultipleY':
    case 'forEachQuantityXGetPercentOffQuantityY':
    case 'forEachQuantityXGetPercentOffQuantityMultipleY':
    case 'forEachQuantityXGetQuantityYforFixedPrice':
    case 'forEachQuantityXQuantityYforFixedPrice':
    case 'forEachQuantityXQuantityYQuantityZforFixedPrice':
      return t('common.buyMore');
    default:
      return t('common.discount');
  }
};
// Coupon Status,Used in Coupon and CouponBanner component
export const PROMOTION_REDEEMED_STATUS = {
  REDEEMED: 'REDEEMED',
  ACTIVE: 'ACTIVE',
  USED: 'USED',
  EXHAUSTED: 'EXHAUSTED',
  UNAVAILABLE: 'UNAVAILABLE',
  EXPIRED: 'EXPIRED'
};
export const MAXIMUM_PRICE_RANGE = 999;
const MIN_THRESHOLD = 0.1;
export const getCouponThresholdDescription = promotion => {
  if (!promotion || !promotion.promotionCategory) return '';
  if (!promotion.thresholds || !promotion.thresholds.length) {
    return '';
  }
  const thresholds = promotion.thresholds;
  switch (promotion.promotionCategory) {
    case 'buyAmountXGetPercentOffX':
    case 'buyAmountXGetAmountOffY':
    case 'buyAmountXGetAmountOffX':
      return t('modules.couponsList.AVAILABLE_FOR_OVER_AMOUNT', {
        AMOUNT: thresholds[0].currencyAmount.amount
      });
    case 'buyQuantityXGetPercentOffX':
    case 'buyQuantityXGetAmountOffX':
    case 'buyQuantityXGetQuantityFreeX':
      return t('modules.couponsList.AVAILABLE_FOR_OVER_QUANTITY_YUAN', {
        QUANTITY: thresholds[0].quantity
      });
    case 'forEachQuantityXGetPercentOffQuantityX':
    case 'forEachQuantityXGetAmountOffX':
    case 'forEachQuantityXGetQuantityFreeX':
      return t('modules.couponsList.FOREACH_QUANTITY_GET_QUANTITY_FREE', {
        QUANTITY: thresholds[0].quantity
      });
    case 'discountCheapestNofM':
      return t('modules.couponsList.DISCOUNT_CHEAPEST_NOF_M', {
        QUANTITY: thresholds[0].quantity
      });
    case 'buyAmountXGetShippingFreeX':
    case 'buyAmountXGetSimpleShippingFreeX':
      return thresholds[0].currencyAmount.amount <= MIN_THRESHOLD
        ? t('modules.couponsList.ZERO_THRESHOLD_IS_AVAILABLE')
        : t('modules.couponsList.AVAILABLE_FOR_OVER_AMOUNT', {
            AMOUNT: thresholds[0].currencyAmount.amount
          });
    case 'buyQuantityXGetShippingFreeX':
    case 'buyQuantityXGetSimpleShippingFreeX':
      return t('modules.couponsList.FREE_SHIPPING_FOR_X_PIECES', {
        QUANTITY: thresholds[0].quantity
      });
    default:
      return '';
  }
};
